import React, { useRef } from "react"
import { AreaHistoryLineChart, AreaLineChart } from "../../components/AreaChart"
import { BarometerChart } from "../../components/BarometerChart"
import { Button, ButtonLoader } from "../../components/Button"
import { CardTitle, CardTitleWithContent } from "../../components/Card"
import { SizeMe } from "react-sizeme"
import { EsmListIndex } from "../../components/EsmListIndex"
import { ScalePillDescription } from "../../components/ScalesPillDescription"
import { EscalaLabel } from "../../components/EscaleBar"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { Grid, HeatMapTable } from "../../components/Table"
import { CheckBox, FormGroup, FormRow, Input, Label, SelectInput } from "../../components/Form"
import { useCities } from "../../core/utils/hooks/useCities"
import CodesValuesContainer from "../../container/CodesValuesContainer"
import { PickerWithType, DatePicker } from "../../components/DatePicker"
import { RiMore2Fill } from "react-icons/ri"
import "./styles.scss"
import CsvReader from "../../components/CSVIds"
import CodesValuesContainerFixed from "../../container/CodesFixedValuesContainer"
import useIntersectionObserver from "../../core/utils/hooks/useIntersectionObserver"
import { LoadingWithLabel } from "../../components/Loading"

export const getType = (conceito) => {
  if (conceito === "Alto") {
    return "extraHigh"
  } else if (conceito === "Bom") {
    return "high"
  } else if (conceito === "Médio") {
    return "medium"
  } else if (conceito === "Baixo") {
    return "low"
  } else if (conceito === "Ruim") {
    return "extraLow"
  }
}

const getPercentual = (data, conceito) => {
  if (!Array.isArray(data) || data?.length === 0) {
    return 0
  }
  return parseFloat(
    (data?.filter((item) => item.details?.Conceito === conceito)?.length / data?.length) * 100,
  ).toFixed(0)
}

const columns = [
  {
    id: "checkbox",
    name: "checkbox",
  },
  {
    id: "name",
    field: "name",
    label: "Ação",
    width: "400px",
    cellRenderer: ({ index, value, data, tableManager }) => (
      <div className="rgt-cell-inner action">
        <div className="mnj-table-user-component">
          <div className="mnj-table__item-icon">
            {/* <AvatarIcon
            icon={data?.image}
            name={data?.name}
          /> */}
          </div>
          <div className="mnj-table-user-component-info">
            <span className="mnj-table-user-component-info-name">{data?.name}</span>
            <span className="mnj-table-user-component-info-email">{data?.email}</span>
          </div>
        </div>
      </div>
    ),
  },
]

const ModalESM = ({
  modalIsOpen,
  users,
  changeOptions,
  selectedsUsers,
  handleCloseModal,
  handleProcessUsers,
  saving,
  register,
  setCodesValuesProcessing,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader title="Processar dados" closeModal={handleCloseModal}>
        <CsvReader handleSelectedList={changeOptions} users={users} getOnlyUserId />
      </ModalHeader>
      <ModalBody className="modal-container-producer__esm">
        <Grid
          isPaginated={false}
          columns={columns}
          rows={users}
          height={500}
          // value={selectedsUsers}
          onSelectedRowsChange={changeOptions}
        />
        <div className="code-dates-container">
          <FormRow>
            <FormGroup>
              <div className="form-box">
                <div className="form-date">
                  <Label label="Data inicial" />
                  <Input name="start" type="date" register={register("start")} />
                </div>
                <div className="form-date">
                  <Label label="Data final" />
                  <Input name="end" type="date" register={register("end")} />
                </div>
              </div>
            </FormGroup>
          </FormRow>
          <CodesValuesContainer setValues={setCodesValuesProcessing} isProcessingUser={true} />
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonLoader
          label="Confirmar"
          color="orange"
          isDisabled={saving || selectedsUsers?.length === 0}
          handleClick={handleProcessUsers}
          loading={saving}
        />
      </ModalFooter>
    </ModalPanel>
  )
}

const ModalCategoryHeatMap = ({
  modalIsOpen,
  handleCloseModal,
  checkedCategory,
  categories,
  handleChangeCategories,
}) => {
  const renderCategoryCheckboxes = (categoryLabel) => {
    return (
      <>
        <Label label={categoryLabel} />
        {categories[categoryLabel]?.map((item) => (
          <CheckBox
            key={item.value}
            label={item.value}
            onChange={handleChangeCategories}
            value={item.value}
            checked={checkedCategory?.some((val) => val === item.value)}
          />
        ))}
      </>
    )
  }

  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader title="Categorias" closeModal={handleCloseModal} />
      <ModalBody className="heatmap-category-modal">
        <>
          {renderCategoryCheckboxes("Biologico")}
          {renderCategoryCheckboxes("Quimico")}
        </>
      </ModalBody>
      {/* <ModalFooter>
        <ButtonLoader
          label="Confirmar"
          color="orange"
          isDisabled={saving || selectedsUsers?.length === 0}
          handleClick={handleProcessUsers}
          loading={saving}
        />
      </ModalFooter> */}
    </ModalPanel>
  )
}

const CategoryCards = ({ indicatorsData }) => {
  const categorizeIndicators = (data) => {
    const categorized = {}

    data.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== "monthYear" && key !== "N.º de Produtores") {
          const [category, indicator] = key.split("-")
          if (!categorized[category]) {
            categorized[category] = []
          }
          categorized[category].push({ name: key, value: item[key], monthYear: item.monthYear })
        }
      })
    })

    return categorized
  }

  const categorizedData = categorizeIndicators(indicatorsData)

  return (
    <div className="category-cards-container">
      {Object.keys(categorizedData).map((category) => (
        <div key={category} className="card comunity-producer comunity-producer--vale">
          <CardTitle title={`Evolução dos indicadores - ${category}`} />
          {indicatorsData && indicatorsData.length > 0 && (
            <AreaHistoryLineChart
              data={indicatorsData.map((d) => {
                const filteredData = {}
                filteredData["monthYear"] = d["monthYear"]
                categorizedData[category].forEach((indicator) => {
                  filteredData[indicator.name.replace(`${category}-`, "")] = d[indicator.name]
                })
                return filteredData
              })}
            />
          )}
        </div>
      ))}
    </div>
  )
}

const FilterModal = ({
  cityOptions,
  modalIsOpen,
  setModalIsOpen,
  hasButtons = true,
  sendValues,
  setValuesCodeSearch,
  setResponseCodesSearch,
  valuesCodeSearch,
  isSearch,
  setIsSearch,
  setLoadingSearch,
  loadingSearch,
  filter,
  control,
  onChangeFilter,
  filterByQuestionId,
  filterQuestionsByCode,
  esmId,
  resetFields,
  setResetFields,
  projectsByScope,
  onClearLocalFilters,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Filtro"></ModalHeader>
      <ModalBody className="filter-modal-esm-input">
        <>
          {esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc" ? (
            <></>
          ) : (
            <>
              <Label label="Cidade">
                <SelectInput
                  handleChange={onChangeFilter("city")}
                  selectedValue={filter?.city}
                  closeMenuOnSelect={true}
                  isSearchable={true}
                  isClearable={true}
                  name="city"
                  options={cityOptions}
                  control={control}
                  isOverModal={true}
                />
              </Label>
              <Label label="Projeto">
                <SelectInput
                  handleChange={onChangeFilter("projects")}
                  defaultValue={filter?.projects}
                  closeMenuOnSelect
                  isSearchable
                  isClearable
                  isMulti
                  name="projects"
                  options={
                    projectsByScope &&
                    projectsByScope.map((row) => ({ value: row.id, label: row?.description }))
                  }
                  control={control}
                />
              </Label>
            </>
          )}
        </>
        <CodesValuesContainerFixed
          {...{
            esmId,
            setValues: setValuesCodeSearch,
            setResponseCodesSearch,
            values: valuesCodeSearch,
            isSearch,
            setIsSearch,
            setLoadingSearch,
            loadingSearch,
            resetFields,
            setResetFields,
          }}
        />
        <CodesValuesContainer
          filterByQuestionId={filterByQuestionId}
          setValues={setValuesCodeSearch}
          values={valuesCodeSearch}
          setResponseCodesSearch={setResponseCodesSearch}
          isSearch={isSearch}
          setIsSearch={setIsSearch}
          setLoadingSearch={setLoadingSearch}
          loadingSearch={loadingSearch}
          resetValues={!modalIsOpen}
          filterQuestionsByCode={filterQuestionsByCode}
          esmId={esmId}
          resetFields={resetFields}
          setResetFields={setResetFields}
          onClearLocalFilters={onClearLocalFilters}
        />
      </ModalBody>
      {hasButtons && (
        <ModalFooter>
          <Button
            className="button-engagement"
            label="Limpar"
            variant="outline"
            handleClick={() => setResetFields(true)}
            color="orange"
          />
          <ButtonLoader
            className="button-engagement"
            label="Buscar"
            loading={loadingSearch}
            messageProcess={loadingSearch && "Buscando dados..."}
            handleClick={sendValues}
            color="orange"
          />
        </ModalFooter>
      )}
    </ModalPanel>
  )
}

const EvolutionCharts = ({summaryData, indicatorsData}) => {
  const ref = useRef(null);
  const isVisible = useIntersectionObserver(ref, { threshold: 0.1 });

  return (
    <div ref={ref}>
      {isVisible ? (
        <>
          <div className="card comunity-producer comunity-producer--vale">
          <CardTitle title={"Evolução dos produtores"}/>
          {summaryData && summaryData.length > 0 && <AreaHistoryLineChart data={summaryData}/>}
          </div>
          {indicatorsData && indicatorsData.length > 0 && <CategoryCards indicatorsData={indicatorsData}/>}
          </>
      ) : (
        <div className="card comunity-producer comunity-producer--vale">
          <LoadingWithLabel labelLoading="Carregando gráficos..." colorSpinner="primary"/>
        </div>
      )}
    </div>
  );
};

const ESMScreen = ({
  pageRef,
  data,
  esmUsersList,
  users,
  handleCloseModal,
  modalIsOpen,
  setModalIsOpen,
  selectedsUsers,
  changeOptions,
  goTo,
  goToEsm,
  changeCheck,
  handleProcessUsers,
  saving,
  history,
  register,
  loading,
  onDeleteUser,
  isDeletable,
  colorsByMonthYear,
  setModalFilterIsOpen,
  modalFilterIsOpen,
  handleChange,
  selectedCity,
  setFilterCodesValues,
  setCodesValuesProcessing,
  handleClick,
  sendValues,
  setValuesCodeSearch,
  setResponseCodesSearch,
  valuesCodeSearch,
  isSearch,
  setIsSearch,
  setLoadingSearch,
  loadingSearch,
  esmId,
  filter,
  control,
  onChangeFilter,
  onChangeFilterSearch,
  layoutConfig,
  filterByQuestionId,
  setSelectedEvolution,
  scrollToTopOrBottom,
  filterQuestionsByCode,
  resetFields,
  setResetFields,
  categoryIsOpen,
  categoryCloseModal,
  checkedCategory,
  categories,
  handleChangeCategories,
  allHeaderVariables,
  projectsByScope,
  summaryData,
  indicatorsData,
  goToUser,
  onClearLocalFilters,
  onDateChange,
  dateFilterLoading
}) => {
  const cityOptions = useCities(users) || []

  return (
    <>
      <div className="esm-screen-input" ref={pageRef}>
        <div className="esm-input-field">
          <Input
            placeholder={
              esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                ? "Pesquisar Empreendimento"
                : "Pesquisar"
            }
            hasFocus={false}
            isWhite={true}
            hasIcon={<i class="fi fi-rr-search" />}
            handleClick={handleClick}
            onChange={(e) => onChangeFilterSearch("search", e.target.value)}
          />
        </div>
        <div className="esm-date-filter">
          <DatePicker
            onChange={onDateChange}
            className="class-period"
            placeholder="Selecionar data"
            isWhite={true}
          />
          {dateFilterLoading && (
            <div className="date-filter-spinner">
              <i className="fa fa-spinner fa-spin" />
            </div>
          )}
        </div>
      </div>
      <div className="div-container-sustainability">
        <div className="row-infos">
          <div className="card comunity-producer-card1">
            <CardTitle
              title={
                layoutConfig && layoutConfig?.cards
                  ? layoutConfig?.cards[0].title
                  : "Comunidade de produtores"
              }
            />
            <div className="subtitle">
              <span className="distribution">
                {layoutConfig && layoutConfig?.cards
                  ? layoutConfig?.cards[0]?.scaleIndicator?.title
                  : "Distribuição da comunidade na escala"}
              </span>
              <span className="distribution-count">
                {layoutConfig && layoutConfig?.cards
                  ? layoutConfig?.cards[0]?.scaleIndicator?.subtitle
                  : "Nº de produtores:"}{" "}
                {data?.length || 0}
              </span>
            </div>
            <EscalaLabel
              e5={getPercentual(data, "Alto")}
              e4={getPercentual(data, "Bom")}
              e3={getPercentual(data, "Médio")}
              e2={getPercentual(data, "Baixo")}
              e1={getPercentual(data, "Ruim")}
              {...{ data }}
            />
            <EsmListIndex
              loading={loading}
              data={Array.isArray(esmUsersList) ? esmUsersList.filter((item) => item) : []}
              goTo={goTo}
              checked={selectedsUsers}
              changeOptions={changeOptions}
              isDeletable={isDeletable}
              onDeleteUser={onDeleteUser}
              changeCheck={changeCheck}
              goToUser={goToUser}
              tableLayout={layoutConfig && layoutConfig?.cards && layoutConfig?.cards[0]?.list}
            />
          </div>
          <div className="card comunity-producer-card2">
            <CardTitle
              title={
                layoutConfig && layoutConfig?.cards
                  ? layoutConfig?.cards[1]?.title
                  : "Escala da Comunidade"
              }
            />
            {
              <SizeMe monitorHeight={true}>
                {({ size }) => {
                  return (
                    <div style={{ position: "relative", left: -10, width: "calc(100% + 27px)" }}>
                      <BarometerChart height={size.height} width={size.width} data={data} />
                    </div>
                  )
                }}
              </SizeMe>
            }
            <div className="esm-level">
              <div style={{ display: "flex", alignItems: "start" }}>
                <div className="esm-pill-container">
                  <ScalePillDescription
                    label={
                      esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                        ? "MUITO ALTO"
                        : "ALTO (SUSTENTÁVEL)"
                    }
                    color="darkGreen"
                  />
                  <ScalePillDescription
                    label={
                      esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                        ? "ALTO"
                        : "BOM (QUASE SUSTENTÁVEL)"
                    }
                    color="lightGreen"
                  />
                  <ScalePillDescription
                    label={
                      esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                        ? "MÉDIO"
                        : "MÉDIO (INTERMEDIÁRIO)"
                    }
                    color="yellow"
                  />
                  <ScalePillDescription
                    label={
                      esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                        ? "BAIXO"
                        : "BAIXO (QUASE INSUSTENTÁVEL)"
                    }
                    color="orange"
                  />
                  <ScalePillDescription
                    label={
                      esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                        ? "MUITO BAIXO"
                        : "RUIM (INSUSTENTÁVEL)"
                    }
                    color="red"
                  />
                </div>
                <div className="esm-pill-container">
                  {colorsByMonthYear &&
                    Object.values(colorsByMonthYear).map((color, index) => {
                      const currentDate = Object.keys(colorsByMonthYear)[index]

                      return <ScalePillDescription label={currentDate} customColor={color} />
                    })}
                </div>
              </div>
              <Button
                label={
                  layoutConfig && layoutConfig?.cards
                    ? layoutConfig?.cards[1]?.buttonLabel
                    : "Escala da comunidade"
                }
                handleClick={() => goToEsm()}
              />
            </div>
          </div>
        </div>
        <EvolutionCharts {...{summaryData, indicatorsData}}/>
        {esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc" && (
          <>
            <div className="card comunity-producer comunity-producer--vale">
              <CardTitle
                title={
                  layoutConfig && layoutConfig?.cards
                    ? layoutConfig?.cards[2]?.title
                    : "Evolução da comunidade ao longo do tempo"
                }
              />
              <div
                style={{
                  position: "relative",
                  left: -10,
                  width: "calc(100% + 40px)",
                  display: "flex",
                }}>
                <AreaLineChart data={history} setSelected={setSelectedEvolution} />
              </div>
            </div>
            <div className="card comunity-producer comunity-producer--vale heatmap-table heatmap-table--collapsed">
              <CardTitleWithContent title="Indicadores Químicos e Biológicos das Amostras">
                <button className="indicator-qb-modal" onClick={categoryCloseModal}>
                  <RiMore2Fill size={20} />
                </button>
              </CardTitleWithContent>

              <div className="indicator-qb">
                <div style={{ maxWidth: "100%" }}>
                  <HeatMapTable
                    data={history}
                    filter={checkedCategory}
                    allHeaderVariables={allHeaderVariables || {}}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <ModalESM
          {...{
            modalIsOpen,
            setModalIsOpen,
            users,
            changeOptions,
            selectedsUsers,
            changeCheck,
            handleCloseModal,
            handleProcessUsers,
            saving,
            register,
            setCodesValuesProcessing,
          }}
        />
        <FilterModal
          {...{
            modalIsOpen: modalFilterIsOpen,
            setModalIsOpen: setModalFilterIsOpen,
            cityOptions,
            handleChange,
            selectedCity,
            sendValues,
            setFilterCodesValues,
            setValuesCodeSearch,
            setResponseCodesSearch,
            valuesCodeSearch,
            isSearch,
            setIsSearch,
            setLoadingSearch,
            loadingSearch,
            filter,
            control,
            onChangeFilter,
            filterByQuestionId,
            filterQuestionsByCode,
            esmId,
            resetFields,
            setResetFields,
            projectsByScope,
            onClearLocalFilters,
          }}
        />
        <ModalCategoryHeatMap
          {...{
            modalIsOpen: categoryIsOpen,
            handleCloseModal: categoryCloseModal,
            handleChangeCategories,
            checkedCategory,
            categories,
          }}
        />
      </div>

      <div className="back-to-top" onClick={scrollToTopOrBottom}>
        <i className="fa fa-arrow-up" />
      </div>
    </>
  )
}

export default ESMScreen
